import {useLocalStorage, useMediaQuery} from "usehooks-ts";
import {useEffect} from "react";

const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)'

const useBrowserTheme = ()=>{
    const isDarkPreferred = useMediaQuery(COLOR_SCHEME_QUERY)
    const [theme, setTheme] = useLocalStorage('theme', isDarkPreferred ? 'dark' : 'light')
    const onThemeChange = (theme: string)=>{
        setTheme(theme)
        const th = theme === "auto" ? isDarkPreferred ? 'dark' : 'light' : theme;
        //@ts-expect-error unknown
        const htmlAttrib  = document.getElementsByTagName('html')[0].getAttribute('data-bs-theme')?.value
        if(htmlAttrib !== th){
            if(th === 'dark') {
                document.body.classList.add('bp5-dark')
            }else{
                document.body.classList.remove('bp5-dark')
            }
            document.getElementsByTagName('html')[0].setAttribute('data-bs-theme', th)
        }
    }
    useEffect(()=>{
        onThemeChange(theme)
    }, [])

    return {theme, setTheme:onThemeChange}
}
export default useBrowserTheme
